var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { background: "transparent" }, attrs: { id: "sitet" } },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c("h1", { staticClass: "mb-3" }, [_vm._v(_vm._s(this.title))]),
          ]),
          _vm._m(0),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-8 my-3" }, [
      _c("p", [_vm._v("Em breve.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }